import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

// Shared dayjs setup for relative time + duration helpers.
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(customParseFormat)

export { dayjs }
